import React, { createContext, ReactNode, useContext, useReducer } from 'react';
import { ThemeProvider } from 'styled-components/macro';

import { lightTheme } from './Light/lightTheme';
import { adriagateTheme } from './Adriagate/adriagateTheme';
import GlobalStyles from './GlobalStyles';

const THEME_KEY = 'RENTISTIC_THEME';
const THEME_CHANGE = 'THEME_CHANGE';

interface IThemeState {
  themeName: string;
}

type ThemeAction = { type: 'THEME_CHANGE'; themeName: string };

const initialState: IThemeState = {
  themeName: window.localStorage?.getItem(THEME_KEY) ?? 'light',
};

export const ThemeState = createContext({
  ...initialState,
  changeTheme: (_themeName: string) => {},
});

export const useThemeState = () => useContext(ThemeState);

export const getTheme = (themeName: string) => {
  switch (themeName) {
    case 'adriagate':
      return adriagateTheme;
    case 'light':
    default:
      return lightTheme;
  }
};

const reducer = (state: IThemeState, action: ThemeAction) => {
  switch (action.type) {
    case THEME_CHANGE:
      return {
        ...state,
        themeName: action.themeName,
      };
    default:
      return state;
  }
};

export default function ThemeStateProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const changeTheme = (themeName: string) => {
    if (window.localStorage) {
      localStorage.setItem(THEME_KEY, themeName);
    }
    dispatch({ type: THEME_CHANGE, themeName });
  };

  const value = {
    ...state,
    changeTheme,
  };

  const theme = { ...getTheme(state.themeName) };

  return (
    <ThemeState.Provider value={value}>
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyles />
          {children}
        </>
      </ThemeProvider>
    </ThemeState.Provider>
  );
}
